import {useMutation, useQueryClient} from '@tanstack/react-query';
import {API, CreateGuestPayload, FieldsErrorResponse} from '@chekin/api';
import {QUERY_CACHE_KEYS,Guest} from '@chekin/core';
import {useReservation} from 'context/reservation';

type UseGuestMutation = {
  onSuccess?: (data: Guest) => void;
  onError?: (error: FieldsErrorResponse) => void;
  onSettled?: () => void;
  isPatch?: boolean;
};
function useGuestMutation({
  onSuccess,
  onError,
  onSettled,
  isPatch,
}: UseGuestMutation = {}) {
  const queryClient = useQueryClient();
  const {reservationId} = useReservation();

  return useMutation<
    Guest,
    FieldsErrorResponse,
    {id?: string; payload: Omit<CreateGuestPayload, 'reservation_id'>}
  >({
    mutationFn: ({id, payload}) =>
      API.guest.createOrUpdate(
        {data: {id, reservation_id: reservationId || '', ...payload}},
        isPatch,
      ),
    onSuccess: async data => {
      await queryClient.refetchQueries({queryKey: [QUERY_CACHE_KEYS.summary]});
      onSuccess?.(data);
      void queryClient.refetchQueries({queryKey: [QUERY_CACHE_KEYS.reservation]});
      void queryClient.refetchQueries({queryKey: [QUERY_CACHE_KEYS.summary]});
      void queryClient.resetQueries({queryKey: [QUERY_CACHE_KEYS.formFields]});
      void queryClient.refetchQueries({queryKey: [QUERY_CACHE_KEYS.guestGroup]});
      queryClient.setQueryData([QUERY_CACHE_KEYS.guest, data.id], data);
    },
    onError,
    onSettled,
  });
}

export {useGuestMutation};
